import { render, staticRenderFns } from "./EmailPerformanceCard.vue?vue&type=template&id=53c3c9d4&scoped=true"
import script from "./EmailPerformanceCard.vue?vue&type=script&lang=js"
export * from "./EmailPerformanceCard.vue?vue&type=script&lang=js"
import style0 from "./EmailPerformanceCard.vue?vue&type=style&index=0&id=53c3c9d4&prod&lang=scss&scoped=true"
import style1 from "./EmailPerformanceCard.vue?vue&type=style&index=1&id=53c3c9d4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c3c9d4",
  null
  
)

export default component.exports